import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { FieldFeature } from '../types';

const getFieldFeatures = (state: AppState) => state.field.features;
const getFeatureKey = (_state: AppState, key: FieldFeature) => key;

export const isFieldFeatureAvailable = createSelector(
  [getFieldFeatures, getFeatureKey],
  (fieldFeatures, feature) => fieldFeatures.includes(feature)
);
